import ApiServer from "../ApiServer.ts";
import FizConfig from "../FizConfig.ts";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import {BaseCache,ListCache,SyncCache, TranslationCache} from "../lib/SyncCache.ts";
import { protoExtend } from "../lib/ObjectUtil.ts";

import { TaskCache,TaskCategoryCache,TaskListCache} from "./objects/TaskBeans.ts"
import { ContactCache } from "../contact/ContactCache.ts";
import { PlaceCache } from "./objects/MapBeans.ts";

const evtcallistprepared = ApiServer.evtcallist.prepare(true,true,true,true,true,true,true,function(res){
  var calendarList = [].concat(res.mine).concat(res.external?res.external:[]).concat(res.families).concat(res.timetables).concat(res.budgets).filter(cal=>cal!==undefined);
  var calendarByid = {};
  res.activatedIds = [];
  res.googles.concat(res.outlooks).forEach(credential=>{
    calendarList = calendarList.concat(credential.linked);
    credential.linked.forEach(cal=>{
      cal.rights.canShare = true;
    });
  });
  if(res.external){
    res.external.forEach(cal=>{
      cal.rights.canShare = true;
    });
  }
  calendarList.forEach(cal=>{
    calendarByid[cal.metaId] = cal;
    if(cal.activated && !cal.calendars){
      res.activatedIds.push(cal.metaId)
    }
    if(cal.calendars){
      cal.calendars.forEach(subCalendar=>{
        calendarList.push(subCalendar)
        calendarByid[subCalendar.metaId] = subCalendar
        if(cal.activated && subCalendar.activated){
          res.activatedIds.push(subCalendar.metaId)
        }
      })
    }
  });
  res.timetables.forEach(c=>{
    //set a back reference to Calendarbean
    c.timetable.calendar = c
    //cache timetable
    FwDatas.cache(c.timetable)
  })
  //TODO verify if this this list is used and if not remove it
  res.list = calendarList;
  res.byId = calendarByid;
  return res;
})

class CalListCacheClass extends BaseCache<ApiServer.types.CalendarGroupBean>{
  syncCacheById : {[key:string]:ListCache<ApiServer.types.IEvent>}
  constructor(){
    super(evtcallistprepared)
    this.syncCacheById = {};
  }
  //get an element in the current cache out of date or not
  getCache(metaId :string){
    if(!this.syncCacheById[metaId]){
      if(metaId.indexOf('calendarFolder/')===0 || metaId.indexOf('calendarFolderOtherFamilies/')===0){
        this.syncCacheById[metaId] = new ListCache(async ()=>{return []})
      }else if(metaId.indexOf('calendarTask/')===0){
        this.syncCacheById[metaId] = buildTaskAsEventCache(metaId)
      }else{
        if(metaId.indexOf('calendarSpecialDays/')===0){
          var
            rawCache = new SyncCache<ApiServer.types.IEvent>(ApiServer.evtsync.prepare(null,null,metaId)),
            cache = new TranslationCache(rawCache,(events)=>{
              var
                calendar = this.datas.byId[metaId],
                exceptions = [],
                masterEvents = events.filter(ev=>{
                  ev.calendar = calendar;
                  ev.isSpecialDaysEvent = true;
                  if(ev.recurrencyExceptionOfId) {
                    exceptions.push(ev)
                    return false
                  }
                  ev.recurrencyExceptionMap = new Map()
                  return true;
                })
              exceptions.forEach(ev=>{
                var masterEvent = rawCache.get(ev.recurrencyExceptionOfId)
                if(masterEvent){
                  ev.eventMasterId = masterEvent.metaId;
                  masterEvent.recurrencyExceptionMap.set(ev.occurenceIndex,ev);
                  //recopy what needs to be
                  ev.recurrencyDescriptor = masterEvent.recurrencyDescriptor
                  ev.reminderList = masterEvent.reminderList
                }else{
                  console.log('masterEvent of '+ev.metaId+" does not exists")
                }
              })
              return masterEvents;
            })
            cache.addDependency(CalListCache, ContactCache, TaskListCache, PlaceCache)
            this.syncCacheById[metaId] = cache;
        }else{
          this.syncCacheById[metaId] = new SyncCache<ApiServer.types.IEvent>(ApiServer.evtsync.prepare(null,null,metaId))

        }
      }
    }
    return this.syncCacheById[metaId];
  }
}

function buildTaskAsEventCache(calendarId :string){
  return new TranslationCache<ApiServer.types.IEvent,ApiServer.types.TaskBean>(TaskCache,function(tasks){
    const
      result = [];

    tasks.forEach((task)=>{
      if(task.dueDate){
        var extension = {
          isAttendee(accountId){
            return this.assignee.find((assignee)=>{
              return accountId===assignee.accountId;
            })!==undefined;
          },
          attendeeIds:task.assignee.map(assignee=>assignee.accountId),
          calendarId,
          draggable : task.editable,
          colorDB : undefined,
          isTaskEvent : true
        };
        //taskAsEvent.metaId = task.metaId.replace('task/','taskAsEvent/')
        if(task.assignee.length===1){
          extension.colorDB = task.assignee[0].color
        }
        //disable drag n drop for recurring task
        if(task.recurrencyDescriptor.recurrency!=='NONE'){
          extension.draggable = false;
        }
        result.push(protoExtend(task,extension));
      }
    });
    return result;
  })

}

const CalListCache = new CalListCacheClass();

const EventStore = {
  invalidate(calendarIdFilter=(t=>true)){
    Object.entries(CalListCache.syncCacheById).forEach(([key,value])=>{
      if(calendarIdFilter(key)){
        value.invalidate()
      }
    })
  },
  async getSelectedCalendarIds(){
    return CalListCache.need().then(calendarBean=>{
      return calendarBean.activatedIds
    })
  },

  async getFor(selectedCalendarIds :string[]) :Promise<ApiServer.types.IEvent[]>{
    if(!selectedCalendarIds) {
      selectedCalendarIds = await this.getSelectedCalendarIds()
    }

    ApiServer.setGroupOptions({timeout:60000}); //60sec for calendar instead of 20s because of a user who has 13000 event

    const
      arrayOfArray = await Promise.all(
        selectedCalendarIds.map(calendarId=>CalListCache.getCache(calendarId).need())
      ),
      result = arrayOfArray.flat()

    result.forEach(event=>{
      event.calendar = CalListCache.datas.byId[event.calendarId];
    })
    return result;

  },
  async loadEventsBySync(selectedCalendarIds :string[],selectedMembersIds :string[],range :{start:Date, end:Date}){
    const
      allevents = await this.getFor(selectedCalendarIds),
      intervalEvent = [];
    allevents.forEach((event)=>{
      //handle the filter of attendee
      if(selectedMembersIds.length>0){
        if(selectedMembersIds.find(memberId=>event.isAttendee(memberId))===undefined){
          return;
        }
      }
      event.listInterval(range).forEach(eventInstance=>{
        FwDatas.cache(eventInstance)
        intervalEvent.push(eventInstance);
        eventInstance.colorUI = eventInstance.color = (event.colorDB || event.colorAttendee || event.calendar.color || FizConfig.defaultColor);
      });
    });
    return intervalEvent;
  }
}
//this is only for the color
amplify.subscribe("familyScopeChange",function(){
  CalListCache.invalidate();
  EventStore.invalidate();
});

export {CalListCache,EventStore};